import { jsxs as C, Fragment as M, jsx as m } from "react/jsx-runtime";
import { useStore as T } from "../../../store/index.mjs";
import B from "../../../ui-kit/theme-button.mjs";
import { useState as n } from "react";
import { BadRequest as b } from "@systemeio/util";
import { useMercadoPagoCardBuyOffer as k } from "../api/mercado-pago-api.mjs";
import { MercadoPagoThreeDsModal as O } from "../three-ds/index.mjs";
function v({
  isFetching: l,
  buttonTitle: f,
  buttonDisabled: u,
  setIsFetching: a,
  preSubmit: p,
  handleBadRequest: h
}) {
  const { locale: y } = T(), { mercadoPagoCardBuyOffer: D } = k(), [P, s] = n(!1), [i, g] = n(), [c, w] = n(), d = (o) => {
    window.location.assign(o);
  };
  return /* @__PURE__ */ C(M, { children: [
    /* @__PURE__ */ m(
      B,
      {
        disabled: u,
        type: "submit",
        onClick: async (o) => {
          o.preventDefault(), a(!0);
          try {
            const e = p();
            if (!e) return;
            const r = await window.cardPaymentBrickController.getFormData(), t = await D(
              {
                ...e,
                options: {
                  token: r.token,
                  mercadoPagoPaymentMethod: r.payment_method_id,
                  installments: r.installments
                }
              },
              y
            );
            if (t.threeDsInfo) {
              w(t.threeDsInfo), g(t.redirect), s(!0);
              return;
            }
            d(t.redirect);
          } catch (e) {
            if (e instanceof b)
              h(e);
            else
              throw e;
          } finally {
            a(!1);
          }
        },
        isFetching: l,
        children: f
      }
    ),
    c && /* @__PURE__ */ m(
      O,
      {
        opened: P,
        onComplete: () => {
          s(!1), i && d(i);
        },
        threeDsInfo: c
      }
    )
  ] });
}
export {
  v as MercadoPagoCardPaymentButton
};
